﻿import { Inject, Component } from "@fiqas/angular-utils"
import { IRoutingComponent, RouteConfig } from "@fiqas/ngcomponentrouter";
import { FIQAssist } from "../../app"
import { Application } from "../application"
import { AuthenticationService } from "../../services/authenticationService";
import { IsProcessingService } from "../../services/isProcessingService";

type resetstatus = "unknown" | "ok" | "fail" | "notvalid" | "edit";

@Component({
    module: FIQAssist,
    selector: "newPassword",
    templateUrl: "views/newPassword.html",
    require: {
        application: "^application"
    }
})


class NewPassword implements IRoutingComponent {
    private application: Application;
    private activeMenuItem: string;
    private username: string;
    private newpassword: string;
    private token: string;
    private confirmpassword: string;
    private errortextnew: string = "";
    private status: resetstatus = "unknown";
    private forceTooltip1: boolean = false;
    private forceTooltip2: boolean = false;

    constructor(
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject('$element') private $element: ng.IRootElementService,
        @Inject() private isProcessingService: IsProcessingService,
        @Inject('$rootRouter') private $rootRouter: angular.Router,
        @Inject('$window') private $window: ng.IWindowService,
        @Inject() private AuthenticationService: AuthenticationService
    ) {

    }

    $onInit() {
        this.application.forcedCustomer = ' ';
        this.activeMenuItem = '';
    }

    $onDestroy() {
        this.application.forcedCustomer = null;
    }

    public $routerOnActivate(next?: angular.ComponentInstruction, prev?: angular.ComponentInstruction): ng.IPromise<any> | any {
        this.token = decodeURIComponent(next.params["token"]);
        this.username = decodeURIComponent(next.params["username"]);

        if ((!this.token || this.token === "undefined" || this.token === "true") || (!this.username || this.username === "undefined" || this.username === "true")) {
            this.$rootRouter.navigate(['Home']);
        }
    }

    private async changePassword() {
        if (this.newpassword.length < 8 || this.newpassword.length > 50) {
            this.errortextnew = "NEW_PASSWORD_NOT_ALLOWED";
            this.status = "notvalid";
            this.forceTooltip1 = true;
            this.forceTooltip2 = true;
            this.$timeout(
                () => {
                    this.forceTooltip1 = false
                    this.forceTooltip2 = false;
                }, 2000
            );
        }
        else if (this.newpassword !== this.confirmpassword) {
            this.errortextnew = "NEW_PASSWORDS_NOT_THE_SAME";
            this.status = "notvalid";
            this.forceTooltip1 = true;
            this.forceTooltip2 = true;
            this.$timeout(
                () => {
                    this.forceTooltip1 = false
                    this.forceTooltip2 = false;
                }, 2000
            );
        }
        else {
            try {
                this.isProcessingService.StartProcessing();
                this.AuthenticationService.changePasswordWithResetToken(this.username, this.newpassword, this.token, this.application.Settings.culture);
                this.status = "ok";
            }
            catch (error) {
                this.status = "fail";
            }
            finally {
                this.isProcessingService.StopProcessing();
            }
        }
    }

    private onChangeConfirm(value) {
        this.confirmpassword = value;
        this.errortextnew = "";
        this.status = "edit";
    }

    private onChangeNew(value) {
        this.newpassword = value;
        this.errortextnew = "";
        this.status = "edit";
    }

    public back() {
        this.$rootRouter.navigate(['Login']);
    }

}
